module.exports = __webpack_public_path__ + "static/media/1_1_feedback_banner.c8ceb016.png";